import { normalizePlayerAdvancedStats } from './leagueMatchStats';

const formatAverage = (value) => value.toFixed(2);

const formatCount = (value) => String(value || 0);

const formatCheckoutPct = (value) => value.toFixed(1);

const formatHighFinish = (value) => String(value || 0);

export const buildMatchResultStatRows = (player1Stats, player2Stats) => {
  const player1Advanced = normalizePlayerAdvancedStats(player1Stats.advancedStats);
  const player2Advanced = player2Stats
    ? normalizePlayerAdvancedStats(player2Stats.advancedStats)
    : null;

  const rows = [
    {
      label: 'AVRG',
      player1Value: formatAverage(player1Stats.average),
      player2Value: player2Stats ? formatAverage(player2Stats.average) : undefined,
    },
  ];

  if (player1Stats.totalAverage !== undefined || player2Stats?.totalAverage !== undefined) {
    rows.push({
      label: 'AVG TOTAL',
      player1Value: player1Stats.totalAverage !== undefined ? formatAverage(player1Stats.totalAverage) : '-',
      player2Value: player2Stats
        ? (player2Stats.totalAverage !== undefined ? formatAverage(player2Stats.totalAverage) : '-')
        : undefined,
      tone: 'secondary',
    });
  }

  rows.push(
    {
      label: '180',
      player1Value: formatCount(player1Stats.count180s),
      player2Value: player2Stats ? formatCount(player2Stats.count180s) : undefined,
      tone: 'highlight',
    },
    {
      label: '100+',
      player1Value: formatCount(player1Advanced.count100Plus),
      player2Value: player2Advanced ? formatCount(player2Advanced.count100Plus) : undefined,
    },
    {
      label: '140+',
      player1Value: formatCount(player1Advanced.count140Plus),
      player2Value: player2Advanced ? formatCount(player2Advanced.count140Plus) : undefined,
    },
    {
      label: 'Checkout %',
      player1Value: formatCheckoutPct(player1Advanced.checkoutPct),
      player2Value: player2Advanced ? formatCheckoutPct(player2Advanced.checkoutPct) : undefined,
    },
    {
      label: 'High Finish',
      player1Value: formatHighFinish(player1Advanced.highFinish),
      player2Value: player2Advanced ? formatHighFinish(player2Advanced.highFinish) : undefined,
    },
  );

  return rows;
};